import { FilmBadgeData } from "@utils/film-badges"
import { cn } from "@utils/tw"
import { memo, ReactNode } from "react"

type Props = {
  badges: FilmBadgeData[]
  className?: string
}

export const EventBadges = memo((props: Props) => {
  return (
    <>
      {props.badges.map((badge, i) => {
        const styles = STYLES[badge.type]
        return (
          <span
            key={i}
            className={cn(
              "inline-block type-label-s-light pt-[0.4em] pb-[0.2em] px-[0.6em]",
              (styles?.className ?? "bg-grey2 text-black") + " " + props.className,
            )}
          >
            {badge.label}
          </span>
        )
      })}
    </>
  )
})

const STYLES = {
  "sold-out": {
    className: "bg-red text-black",
  },
  "selling-fast": {
    className: "bg-yellow text-black",
  },
  event: {
    className: "bg-purple text-black",
  },
  short: {
    className: "bg-green text-black",
  },
} as {
  [K in FilmBadgeData["type"]]?: {
    icon?: ReactNode
    className?: string
  }
}
